/* eslint-disable react-hooks/exhaustive-deps */
import { notification } from 'antd'
import { useMutation, useQueryClient } from 'react-query'
import { useTranslation } from 'react-i18next'
import { useCallback, useContext } from 'react'

import { QUERY_KEYS } from '@api'
import {
  DeleteTicketNotificationContext,
  useHandleDeleteTicketModal,
  useHandleTicketModal,
} from '@contexts'

import { TicketsApi } from './api'

const useDeleteTicket = () => {
  const { setIsDeleteTicketModalOpen } = useHandleDeleteTicketModal()
  const { t } = useTranslation()
  const { ticketDeleteId } = useContext(DeleteTicketNotificationContext)
  const { isTicketModalOpen } = useHandleTicketModal()

  const onError = () => {
    notification.error({
      message: t('suppliers_router.suppliers_dashboard.use_delete_tickets.error'),
    })
  }

  const onSuccess = useCallback(() => {
    notification.success({
      message: [
        t('suppliers_router.suppliers_dashboard.use_delete_tickets.success'),
        ` ID ${ticketDeleteId}`,
      ],
    })
    if (isTicketModalOpen) {
      const closeTicketModal = document.querySelector(
        '[target="closeModalButton"]',
      ) as unknown as HTMLButtonElement
      closeTicketModal.click()
    }
  }, [ticketDeleteId, isTicketModalOpen])

  const queryClient = useQueryClient()

  const onDeleteSuccess = useCallback(() => {
    setIsDeleteTicketModalOpen(false)
    onSuccess()
    queryClient.invalidateQueries(QUERY_KEYS.TICKETS)
    queryClient.invalidateQueries(QUERY_KEYS.TICKETS_COUNT)
  }, [onSuccess])

  const { mutate, isLoading } = useMutation(TicketsApi.deleteTicket, {
    onSuccess: onDeleteSuccess,
    onError,
  })

  return {
    deleteTicket: mutate,
    isLoading,
  }
}

export { useDeleteTicket }
